import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, compose, createStore} from 'redux';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter} from 'react-router-dom';
import reducer from './js/reducers/reducers';
import loginState from './js/states/LoginState';
import loginAPIMiddleware from './js/middlewares/LoginAPIMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = createStore(reducer, loginState, composeEnhancers(applyMiddleware(loginAPIMiddleware)));
window.store = store;


render(
    <Provider store={store} >
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
//registerServiceWorker();
